//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Tooltip,
  Button,
} from '@mui/material';

 import {
  Done,
  DoneAll,
  DoneOutline,
} from '@mui/icons-material';

// === STORE ===
import { actions } from 'store/modules/correctionMode';

// === API ===
import { onCorrectionMode, removeListener, requestCorrectionMode, setCorrectionModeAll, setCorrectionModeExceptions, toggleCorrectionMode } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function CorrectionMode() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const [ mode , setMode ] = useState( 'CORRECT-EXCEPTIONS' );
  const is_correct_all = mode === 'CORRECT-ALL';
  const toggle_mode_text = is_correct_all ? 'Toggle Correct Exeptions' : 'Toggle Correct All Mode';
  const icon = is_correct_all ? <DoneAll /> : <Done />;

  const _styles = {
    toggle: {
      margin: '0 0.5rem',
    }
  }

  //#endregion

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleCorrectionMode(data) {
      //-----------------------------------------------------------------
      setMode( data );
    }

    onCorrectionMode( handleCorrectionMode );
    requestCorrectionMode();
    
    return () => {
      removeListener( 'CORRECTION-MODE', handleCorrectionMode );
    };
  }, [] )

  //#region [EVENTS]  
 
  //#endregion

  //#region [MODIFY]

  //-----------------------------------------------------------------
  function handleToggleCorrectionMode() {
    //-----------------------------------------------------------------
         if( mode === 'CORRECT-ALL'        ) setCorrectionModeExceptions();
    else if( mode === 'CORRECT-EXCEPTIONS' ) setCorrectionModeAll();
    else setCorrectionModeExceptions();
    
    setMode( prevMode => prevMode ==='CORRECT-ALL' ? 'CORRECT-EXCEPTIONS' : 'CORRECT-ALL' );
  };

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Tooltip title={toggle_mode_text}>
        <Button
          name='toggle_correction_mode_btn'
          sx={_styles.toggle}
          variant='contained'
          color='primary'
          onClick={() => {
            handleToggleCorrectionMode();
          }}
        >
          {icon}
        </Button>
      </Tooltip>
    );
  }

  //#endregion

  return display();
}
